// ======================================================================
// File Name       : ContentNotificationRegisterUpdateContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import ContentSearchForm from '../../components/content/ContentNotificationSearchInput';
import ContentAddMessage from '../../components/content/ContentNotificationAddMessage';
import ConfirmDialog from '../../components/content/ContentNotificationConfirmDialog';
import * as ContentAction from '../../actions/content/ContentAction';
import * as Constant from '../../constants/index';
import * as Path from '../../constants/PathConstants';
import Header from '../../components/Header';

class ContentNotificationRegisterUpdateContainer extends Component {
  constructor() {
    super();
    this.state = {
      mode: Constant.MODE.NEW_MODE,
      notificationDetail: {
        notifyMessageList: [],
        notifyMessageSetSecernId: '',
        notifyMessageSetName: '',
      },
      showModal: false,
      enableAddButton: true,
      timeCondition: '',
      messageZipFileName: '',
      isExistIdInList: false,
      file: null,
      tempMessageId: -1,
      showConfirmModal: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onAddFileButtonClick = this.onAddFileButtonClick.bind(this);
    this.onDialogOk = this.onDialogOk.bind(this);
    this.onDialogCancel = this.onDialogCancel.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.showEditDialog = this.showEditDialog.bind(this);
    this.onDeleteMessage = this.onDeleteMessage.bind(this);
    this.onRegistUpdateButtonClick = this.onRegistUpdateButtonClick.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.validation = this.validation.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(ContentAction.resetContentNotificationRegister());
  }

  componentDidMount() {
    this.getContentNotificationDetail(this.props, false);
  }

  componentWillReceiveProps(nextProps) {
    const { notification } = nextProps.content;
    if (!this.state.isExistIdInList) {
      this.getContentNotificationDetail(nextProps, true);
    }
  }

  getContentNotificationDetail(props, isReceivedProps) {
    const { content, match, dispatch } = props;
    const { notification } = content;
    const { search } = notification;
    const { notifyMessageList } = search;
    let mode = Constant.MODE.NEW_MODE;
    if (isReceivedProps) {
      mode =
        match.params.id && notifyMessageList.length > 0
          ? Constant.MODE.EDIT_MODE
          : Constant.MODE.NEW_MODE;
    } else {
      mode = match.params.id ? Constant.MODE.EDIT_MODE : Constant.MODE.NEW_MODE;
    }
    this.setState({ mode });
    if (mode === Constant.MODE.EDIT_MODE) {
      const index = notifyMessageList.findIndex(
        item => item.notifyMessageSetSecernId === match.params.id,
      );
      if (index >= 0) {
        const notificationDetail = notifyMessageList[index];
        const isExistIdInList = true;
        this.setState({
          notificationDetail,
          isExistIdInList,
        });
      } else if (isReceivedProps) {
        this.setState({
          mode: Constant.MODE.NEW_MODE,
          isExistIdInList: true,
        });
      } else {
        const params = {
          notifyMessageSetSecernId: match.params.id,
        };
        this.props.dispatch(ContentAction.contentNotificationSearch(params));
      }
    } else {
      this.setState({ isExistIdInList: true });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    if (name === 'notifyMessageSetSecernId' || name === 'notifyMessageSetName') {
      const notificationDetail = { ...this.state.notificationDetail, ...{ [name]: value } };
      this.setState({
        notificationDetail,
      });
    }
    if (name === 'timeCondition') {
      this.setState({ [name]: value });
    }
  }

  onAddFileButtonClick(event) {
    if (event.target.files && event.target.files.length !== 0) {
      const file = event.target.files[0];
      const messageZipFileName = file.name;
      this.setState({ messageZipFileName, file });
    }
  }

  onDialogOk() {
    const { tempMessageId } = this.state;
    const { notificationDetail } = this.state;
    if (tempMessageId >= 0 && tempMessageId < notificationDetail.notifyMessageList.length) {
      notificationDetail.notifyMessageList[tempMessageId].timeCondition = this.state.timeCondition;
      notificationDetail.notifyMessageList[
        tempMessageId
      ].messageZipFileName = this.state.messageZipFileName;
      notificationDetail.notifyMessageList[tempMessageId].messageZipFile = this.state.file;
    } else {
      const item = {
        timeCondition: this.state.timeCondition,
        messageZipFileName: this.state.messageZipFileName,
        messageZipFile: this.state.file,
      };
      notificationDetail.notifyMessageList.push(item);
    }
    this.setState({ notificationDetail, showModal: false });
  }

  onDialogCancel() {
    this.setState({ showModal: false, showConfirmModal: false });
  }

  showDialog() {
    this.setState({
      tempMessageId: -1,
      showModal: true,
      timeCondition: '',
      messageZipFileName: '',
      file: null,
    });
  }

  showEditDialog(id) {
    const { notifyMessageList } = this.state.notificationDetail;
    if (id < 0 || id >= notifyMessageList.length) {
      return;
    }
    const timeCondition = notifyMessageList[id].timeCondition;
    const messageZipFileName = notifyMessageList[id].messageZipFileName;
    this.setState({ timeCondition, messageZipFileName, showModal: true, tempMessageId: id });
  }

  onDeleteMessage(id) {
    const { notificationDetail } = this.state;
    if (id < 0 || id >= notificationDetail.notifyMessageList.length) {
      return;
    }
    notificationDetail.notifyMessageList.splice(id, 1);
    this.setState({ notificationDetail });
  }

  onRegistUpdateButtonClick() {
    const isValid = this.validation();
    if (
      !isValid ||
      this.state.notificationDetail.notifyMessageSetName == '' ||
      this.state.notificationDetail.notifyMessageList.length <= 0
    ) {
      return;
    }
    this.setState({ showConfirmModal: true });
  }

  onConfirmDialogOk() {
    this.setState({ showConfirmModal: false });
    const notificationData = {
      notifyMessageList: [],
      notifyMessageSetName: this.state.notificationDetail.notifyMessageSetName,
    };
    this.state.notificationDetail.notifyMessageSetSecernId && (notificationData.notifyMessageSetSecernId = this.state.notificationDetail.notifyMessageSetSecernId);
    const dataList = this.state.notificationDetail.notifyMessageList;
    const listLength = dataList.length;
    for (let i = 0; i < listLength; i++) {
      if (this.state.mode === Constant.MODE.NEW_MODE) {
        notificationData.notifyMessageList.push({
          timeCondition: dataList[i].timeCondition,
          messageZipFileName: dataList[i].messageZipFileName,
        });
      } else {
        notificationData.notifyMessageList.push({
          timeCondition: dataList[i].timeCondition,
          messageZipFileName: dataList[i].messageZipFileName,
          eachNotifyMessageId: dataList[i].eachNotifyMessageId,
        });
      }
      if (dataList[i].messageZipFile) {
        notificationData[`message${i + 1}ZipFile`] = dataList[i].messageZipFile;
      } else {
        notificationData[`message${i + 1}ZipFile`] = null;
      }
    }
    if (this.state.mode === Constant.MODE.NEW_MODE) {
      this.props.dispatch(ContentAction.registerContentNotificationMessage(notificationData));
    } else {
      this.props.dispatch(ContentAction.updateContentNotificationMessage(notificationData));
    }
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const { content } = this.props;
    let isRegisterUpdateSuccessfully = false;
    if (content && content.notification && content.notification.isRegisterUpdateSuccessfully) {
      isRegisterUpdateSuccessfully = content.notification.isRegisterUpdateSuccessfully;
    }
    this.refsToValidate = [];
    if (isRegisterUpdateSuccessfully) {
      return <Redirect to="/content/notification/top" />;
    }
    return (
      <div>
        <Header name={this.state.mode === Constant.MODE.EDIT_MODE ? '通知メッセージ情報の編集' : '通知メッセージ情報の新規登録'}/>
        <Form className='form-horizontal'>
          <ContentSearchForm
            handleChange={this.handleInputChange}
            notifyMessageSetSecernId={this.state.notificationDetail.notifyMessageSetSecernId}
            notifyMessageSetName={this.state.notificationDetail.notifyMessageSetName}
            mode={this.state.mode}
            onRegistUpdateButtonClick={this.onRegistUpdateButtonClick}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
          />
          <ContentAddMessage
            mode={this.state.mode}
            handleChange={this.handleInputChange}
            handleFileChange={this.onAddFileButtonClick}
            messageZipFileName={this.state.messageZipFileName}
            timeCondition={this.state.timeCondition}
            handleOkClick={this.onDialogOk}
            handleCancelClick={this.onDialogCancel}
            handleAddMessage={this.showDialog}
            handleDelteMessage={this.onDeleteMessage}
            handleEditMessage={this.showEditDialog}
            notifyMessageList={this.state.notificationDetail.notifyMessageList}
            showModal={this.state.showModal}
            enableAddButton={this.state.enableAddButton}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
          />
          <Col sm={12} className="text-center margin-top-10 margin-bottom-10">
            {this.state.mode === Constant.MODE.EDIT_MODE && (
              <Link
                className="btn btn-primary btn-96 margin-top-8 margin-right-20"
                role="button"
                to={{
                  pathname: `/${Path.CONTENT}/${Path.CONTENT_DRILL_NOTIFICATION}/${this.state
                    .notificationDetail.notifyMessageSetSecernId}`,
                }}
              >
                キャンセル
              </Link>
            )}
            <Button
              variant="primary"
              className="btn-96 text-center"
              onClick={this.onRegistUpdateButtonClick}
            >
              OK
            </Button>
          </Col>
          <ConfirmDialog
            showModal={this.state.showConfirmModal}
            notificationData={this.state.notificationDetail}
            handleOkClick={this.onConfirmDialogOk}
            handleCancelClick={this.onDialogCancel}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content, auth: state.authed.authedUser },
});

export default connect(mapStateToProps)(ContentNotificationRegisterUpdateContainer);
